export default __webpack_public_path__ + "media/color/fair-f4855208.svg";